import { Checkbox, CheckboxProps } from '@headlessui/react';
import { CheckIcon } from '@heroicons/react/16/solid';
import { cn } from 'utils/utils';

interface AgreementCheckboxProps extends CheckboxProps {
  label: string;
}

const AgreementCheckbox = ({ label, checked, onChange, className, ...props }: AgreementCheckboxProps) => {
  return (
    <div className='flex items-center gap-[8px]'>
      <div
        className={`font-[MuseoSansCyrl] text-[14px] ${checked ? 'text-primary' : 'text-red'} max-sm:text-[12px] max-sm:text-right max-sm:w-fit`}
      >
        {label}
      </div>
      <Checkbox
        checked={checked}
        onChange={onChange}
        className={cn(
          'grow group grid place-items-center w-[20px] h-[20px] rounded-[2px] border transition cursor-pointer data-checked:bg-primary',
          checked ? 'border-primary bg-primary' : 'border-red bg-primary50 ',
          props.disabled && 'cursor-not-allowed opacity-50',
          className
        )}
        {...props}
      >
        <CheckIcon className='hidden w-[16px] h-[16px] fill-white group-data-checked:block' />
      </Checkbox>
    </div>
  );
};

export default AgreementCheckbox;
